import { Box, Typography } from "@mui/material";
import { useTicketContext } from "../../context/ticket/TicketContext";
import { COLORS } from "../../ui/Theme";

const TicketLables = ({ data }) => {
  const { statusDetails } = useTicketContext();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "6px",
      }}
    >
      <Typography
        sx={{
          padding: "4px 8px",
          color: statusDetails[data?.status]?.color,
          bgcolor: statusDetails[data?.status]?.bg,
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 700,
        }}
      >
        {statusDetails[data?.status]?.text}
      </Typography>
      <Typography
        sx={{
          padding: "4px 8px",
          color: COLORS.SOFTBLACK,
          bgcolor: COLORS.SOFTGRAY,
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 700,
        }}
      >
        {data?.receiver}
      </Typography>
      <Typography
        sx={{
          padding: "4px 8px",
          color: COLORS.SOFTBLACK,
          bgcolor: COLORS.SOFTGRAY,
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 700,
        }}
      >
        {data?.feature}
      </Typography>
    </Box>
  );
};

export default TicketLables;
